function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.indicative0{fill:#383C43;}\n\t.indicative1{fill:#21B792;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "indicative0",
  d: "M728.9,155.9L687.8,49.7h36.9l23.7,69.3l23.9-69.3h35.8l-40.6,106.2H728.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "indicative0",
  d: "M0,155.9V49.7h33.9v106.2H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "indicative0",
  d: "M149,86.2v69.7h-33.9V98.2c0-12.7-6.3-19.6-16.8-19.6c-9.4,0-17.2,6.3-17.2,20.1v57.2H47.3V49.7h32.5V63 c6.8-11.2,17.3-16.2,31.6-16.2C132.6,46.8,149,61.6,149,86.2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "indicative0",
  d: "M235.9,59.8V0h33.8v155.9H237v-11.5c-6.5,8.3-16.1,14.3-30.5,14.3c-28.2,0-49.4-24.6-49.4-56.1 c0-31.2,21-55.9,49.5-55.9C220.1,46.8,229.4,52.1,235.9,59.8z M192,102.7c0,13.9,9.1,24.4,22.6,24.4c13.3,0,22.7-10.3,22.7-24.4 s-9.4-24.4-22.7-24.4C201.1,78.4,192,88.9,192,102.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 283.1,
  y: 122,
  className: "indicative1",
  width: 33.9,
  height: 33.9
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "indicative1",
  width: 33.9,
  height: 33.9
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "indicative0",
  d: "M433,69.6l-26.5,18.5c-5.3-6.9-11.4-10.2-19.6-10.2c-11.8,0-21.9,9.2-21.9,24.4c0,15.4,9.8,24.4,21.7,24.4 c7.9,0,14.6-3.5,20-10.3l26.4,18.8c-10.3,14.4-25.7,23.1-45.5,23.1c-33.9,0-57.3-23.5-57.3-56s23.4-56,57.3-56 C407.4,46.3,422.7,55,433,69.6z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "indicative0",
  d: "M516.2,155.9v-11.5c-6.5,8.3-16.1,14.3-30.5,14.3c-28.2,0-49.4-24.6-49.4-56.1c0-31.2,21-55.9,49.5-55.9 c14.3,0,24,6.1,30.4,14.4V49.7H549v106.2H516.2z M471.2,102.7c0,13.9,9.1,24.4,22.6,24.4c13.3,0,22.7-10.3,22.7-24.4 s-9.5-24.4-22.8-24.4C480.3,78.4,471.2,88.9,471.2,102.7L471.2,102.7z"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 645.8,
  y: 99.4,
  className: "indicative0",
  width: 33.9,
  height: 56.5
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "indicative0",
  d: "M912.3,103.3c0,3.5-0.2,7-0.6,10.5h-72c2.9,11.7,11,17,22.7,17c7.9,0,16.3-3.2,23.2-9.3l21.9,20.4 c-11.1,11.1-26.9,17.4-46.8,17.4c-33.3,0-56-22.2-56-55.3c0-33.3,22.1-56.6,54.5-56.6C890.7,47.3,912.3,70.1,912.3,103.3z  M839.8,92.4h38.7c-2.7-10.7-9.2-16.2-19.2-16.2C848.8,76.1,842.4,81.9,839.8,92.4L839.8,92.4z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "indicative1",
  d: "M645.8,83.6V49.7h33.9v33.9H645.8z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "indicative0",
  d: "M283.1,106.2V49.7h33.9v56.5H283.1z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "indicative0",
  d: "M632.5,120.8c-5,3.9-12.6,6.3-21.2,6.3c-9.7,0-15-4.1-15-16.3V80.2h36.2V49.8h-36.2V18.9h-33.9v96.2 c0,26.5,16.1,43.6,41.3,43.6c9.8,0.2,19.6-1.6,28.7-5.2V120.8z"
});

var SvgIndicative = function SvgIndicative(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Assets",
    x: "0px",
    y: "0px",
    viewBox: "0 0 912.3 159.3",
    style: {
      enableBackground: "new 0 0 912.3 159.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIndicative, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/indicative.d5cee04f.svg";
export { ForwardRef as ReactComponent };